export enum HighOrderFunctionType {
  Builtin = "Builtin",
  ExternalCall = "ExternalCall",
  BlockCall = "BlockCall",
}
